<template>
  <div
    class="rr-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="rr-title"
    aria-describedby="rr-desc"
    @click.self="$emit('close')"
  >
    <div ref="card" class="rr-card">
      <div id="rr-title" class="rr-header">
        Response Required
      </div>
      <div class="rr-divider"></div>

      <div class="rr-body">
        <img
          class="rr-icon"
          :src="iCircleUrl"
          alt=""
          aria-hidden="true"
        />
        <p id="rr-desc" class="rr-message">
          You cannot continue with this question unanswered.
        </p>
      </div>

      <div class="rr-actions">
        <button
          ref="ok"
          class="rr-ok"
          data-test="ok-button"
          @click="$emit('close')"
          @keydown.enter.prevent="$emit('close')"
          @keydown.space.prevent="$emit('close')"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import iCircleSimIcon from '@/assets/icons/i-circle-sim.svg';

export default {
  name: 'ResponseRequiredModal',
  emits: ['close'],
  computed: {
    iCircleUrl() {
      return iCircleSimIcon;
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.ok && this.$refs.ok.focus());
    document.addEventListener('keydown', this.onEsc);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  },
  methods: {
    onEsc(e) { if (e.key === 'Escape') this.$emit('close'); },
  },
};
</script>

<style scoped lang="scss">
.rr-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.45);
  display: grid; place-items: center;
  z-index: 100000;
}

.rr-card {
  width: 516px;
  max-width: calc(100vw - 2rem);
  background: #246EAC;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 12px 28px rgba(0,0,0,.25);
  padding: 10px 14px 16px;
}


.rr-header {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  padding: 2px 2px 6px 2px;
}


.rr-divider {
  height: 1px;
  background: rgba(255,255,255,.85);
}


.rr-body {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 2px 10px;
}

.rr-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
}

.rr-message {
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
}


.rr-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}

.rr-ok {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  height: 36px;
  min-width: 72px;
  border-radius: 2px;
  cursor: pointer;
}
.rr-ok:focus {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
</style>
